<template>
  <div class="header">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="8" class="tc">
          <h2>Mind Body Health Center. LLC</h2>
          <p class="headAddress">1806 Springfield Ave.</p>
          <p class="headAddress">New Providence, NJ, 07974</p>
          <p class="headAddress"> Phone: <a href="tel:9084641400" class="headPhone">908-464-1400</a>&nbsp; Fax: 908-464-1344 </p>
        </v-col>
        <v-col cols="4">
          <p>Erika is now running a parent group! <v-btn small href="/parent-group-session.pdf">Click Here</v-btn><br> for more info</p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>

  export default {
    name: "Header"
  }

</script>

<style>
  .header {
    /* font-size: 10px; */
    margin-bottom: 20px;
    font-family: inherit;
    height: 150px;
    border-bottom: 1px black solid;
    background-color: #74a4bc;
    background-image: url(../../public/sunset3.jpg);
    /* padding: 20px; */
  }

  .headAddress {
    margin: 0px;
  }

  .headPhone {
    text-decoration: none;
  }

  .v-application p {
    margin-bottom: 0px !important;
  }

  @media only screen and (max-width: 767px) {
    .header {
      height: 225px;
    }
  }


</style>
